import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './index.css';
import AuthWrapper from './AuthWrapper';
import { ThemeProvider } from './ThemeContext';
import App from './App';
import Home from './Home';
import StoreProducts from './Products';
import Stores from './Stores';
import CouponUpload from './CouponUpload';
import BannerUpload from './BannerUpload';
import ProductUpload from './ProductUpload';
import AdsUpload from './AdsUpload';
import reportWebVitals from './reportWebVitals';

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <AuthWrapper>
        <Home />
      </AuthWrapper>
    ),
  },
  {
    path: "/ads",
    element: (
      <AuthWrapper>
        <App />
      </AuthWrapper>
    ),
  },
  {
    path: "/stores",
    element: (
      <AuthWrapper>
        <Stores />
      </AuthWrapper>
    ),
  },
  {
    path: "/store-products",
    element: (
      <AuthWrapper>
        <StoreProducts />
      </AuthWrapper>
    ),
  },
  {
    path: "/coupons",
    element: (
      <AuthWrapper>
        <CouponUpload />
      </AuthWrapper>
    ),
  },
  {
    path: "/banners",
    element: (
      <AuthWrapper>
        <BannerUpload />
      </AuthWrapper>
    ),
  },
  {
    path: "/products-upload",
    element: (
      <AuthWrapper>
        <ProductUpload />
      </AuthWrapper>
    ),
  },
  {
    path: "/ads-upload",
    element: (
      <AuthWrapper>
        <AdsUpload />
      </AuthWrapper>
    ),
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <RouterProvider router={router} />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
